/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Link from "./link"
import ListingButton from "./listing-button"
import { ab } from "../theme"

const BigBlogTeasers = ({
  heading,
  buttonLink,
  buttonText,
  linkTarget,
  children,
  currentLanguage,
  buttonVariant,
  iconRight,
}) => (
  <div
    className="big-blog-teasers"
    sx={{
      variant: "alternatingSpacingContainer",
      backgroundColor: "secondaryBackground",
      color: "text",
    }}
  >
    <h2
      sx={{
        variant: "bigblogteaser.h2",
      }}
    >
      {heading}
    </h2>
    <div>{children}</div>
    <div
      sx={{
        mt: ab({ _: 2, md: 4 }),
        textAlign: ab({ _: "center", md: "left" }),
        display: buttonText ? "block" : "none",
      }}
    >
      <Link language={currentLanguage} to={buttonLink} target={linkTarget}>
        <ListingButton
          buttonText={buttonText}
          buttonVariant={buttonVariant}
          iconRight={iconRight}
          sx={{
            px: 4,
            py: 2,
            "&:first-letter": {
              textTransform: "uppercase",
            },
          }}
        />
      </Link>
    </div>
  </div>
)

BigBlogTeasers.propTypes = {
  buttonVariant: PropTypes.oneOf(["primary", "secondary", "download"]),
  iconRight: PropTypes.string,
  heading: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  linkTarget: PropTypes.string,
  children: PropTypes.node,
}

export default BigBlogTeasers
